import { ContactTile, ContactTileGlyph } from '@vs-shop/commerce-ui/contactTile';
import { IconQuestionMark } from '@vs-shop/ui/icons';
import type { ClassValue } from 'clsx';

import { clsxm } from '@vs-shop/utils';

import ContactUsProductCardHeading from './ContactUsProductCardHeading';
import ContactUsProductCartForm from './ContactUsProductCartForm';

type Props = {
  className?: ClassValue;
};

/**
 * rcprofi's arrangement of the shared contact tile: the question-mark
 * watermark, the invitation, and this tenant's own contact form under it.
 */
export default function ContactUsProductCard({ className }: Props) {
  return (
    <ContactTile className={clsxm(className)}>
      <ContactTileGlyph render={<IconQuestionMark />} />
      <ContactUsProductCardHeading />
      <ContactUsProductCartForm />
    </ContactTile>
  );
}
